class Reel {

    public id: number;
    private _symbols: any[];
    private _spinSymbols: any[];
    private _resSymbols: any[];
    private _resSymbolsTmp: any[];
    private _symbolsPosition: number;

    public data;

    constructor(id) {

        this.id = id;

        this._symbols = [];
        this._spinSymbols = [];
        this._resSymbols = [];
        this._resSymbolsTmp = [];

        this._symbolsPosition = 0;

        // /**
        //  * @type {ReelSpinner}
        //  * @private
        //  */
        // this._spinner = null;

        /** @type {Object} */
        this.data = {};
    }

    getId(): number {
        return this.id;
    }

    // /**
    //  * @param {ReelSpinner} spinner
    //  */
    // register(spinner) {
    //     this._spinner = spinner;
    // }

    setSpinSymbols(symbols) {
        this._spinSymbols = symbols;
    }

    setSymbolsPosition(pos: number) {
        this._symbolsPosition = (pos + this._resSymbols.length) % this._spinSymbols.length;
	}

    setResSymbols(symbols) {
        this._resSymbols = symbols;
        // this.initSymbols();
    }

    initSymbols() {
        const posStart = this._symbolsPosition;
        let posEnd = this._symbolsPosition - this._resSymbols.length - 1;
        posEnd = posEnd < 0 ? posEnd + this._spinSymbols.length : posEnd;

        let symbolStart = this._symbols[0] || this._spinSymbols[posStart];
        let symbolEnd = this._symbols[this._symbols.length - 1] || this._spinSymbols[posEnd];

        this._symbols.length = 0;
        this._symbols.push(symbolStart);

        for (let i = 0; i < this._resSymbols.length; i++) {
            this._symbols[i + 1] = this._resSymbols[i];
        }

        this._symbols[this._symbols.length] = symbolEnd;
    }

    getSpinSymbols() {
        return this._spinSymbols;
    }

    getResSymbols() {
        return this._resSymbols;
    }

    getResSymbolsTmp() {
        return this._resSymbolsTmp;
    }

    getSymbols() {
        return this._symbols;
    }

    setSpinSymbolsVisible(bool) {
        for(let i = 0, l = this._spinSymbols.length; i < l; i++) {
            this._spinSymbols[i].visible = bool;
        }
    }

    setSymbolsVisible(bool) {
        for(let i = 0, l = this._symbols.length; i < l; i++) {
            this._symbols[i].visible = bool;
        }
    }

    spinNextSymbol() {
        let oldSymbol = this._symbols.pop();
        oldSymbol.visible = false;

        let i = this._getSpinSymbolIndex(1 + this._symbolsPosition++);
        this._spinSymbols[i].visible = true;

        this._symbols.unshift(this._spinSymbols[i]);
    }

    spinNextResSymbol(i) {

        let oldSymbol = this._symbols.pop();
        // oldSymbol.visible = false;
        // this._resSymbols[i].visible = true;

        this._symbols.unshift(this._resSymbols[i]);
    }

    _getSpinSymbolIndex (position) {

        let i = position % this._spinSymbols.length;

        if(i < 0) {
            i = i + this._spinSymbols.length;
        }

        return i;
    }

    /** moves resSymbols to temp, call this method before spin */
    preStartReel () {

        this._resSymbolsTmp.length = 0;
        for(let symbol of this._resSymbols) {
            this._resSymbolsTmp.push(symbol);
        }

        this._resSymbols.length = 0;
    }

    /** removes symbols resSymbols from temp and destroys them, call this method on spin end */
    postStartReel () {

        for(let symbol of this._resSymbolsTmp) {
            symbol.parent.removeChild(symbol);
            if(typeof symbol.destroy === "function") {
                symbol.destroy();
            }
        }

        this._resSymbolsTmp.length = 0;
    }
}

export default Reel;